import { API_G_030_JUCHU_TOIAWASE } from '@/constants/api';
import axios from '@/plugins/axios';
import { dateStrToNum, removeBlankOrNullOrZero } from '@/utils/utils';
import type { Module } from 'vuex';

const g_030: Module<unknown, unknown> = {
  namespaced: true,
  state() {
    return {};
  },
  mutations: {},
  getters: {},
  actions: {
    async getData(_ctx, params) {
      try {
        const { ...newParams } = params;
        const res = await axios({
          url: `${API_G_030_JUCHU_TOIAWASE}`,
          method: 'GET',
          params: {
            ...removeBlankOrNullOrZero(newParams),
          },
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getList error.');
        console.log(err);
        return await Promise.reject(err);
      }
    },
    async getRirekiList(_ctx, params) {
      try {
        const res = await axios({
          url: `${API_G_030_JUCHU_TOIAWASE}/rirekiList`,
          method: 'GET',
          params: removeBlankOrNullOrZero(params),
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getRirekiList error.');
        console.log(err);
      }
    },
    async getRirekiItem(_ctx, params) {
      try {
        const res = await axios({
          url: `${API_G_030_JUCHU_TOIAWASE}/rirekiItem`,
          method: 'GET',
          params: removeBlankOrNullOrZero(params),
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getRirekiItem error.');
        console.log(err);
      }
    },
    async getUchiwake(_ctx, params) {
      try {
        const {
          juchuEntryJigyoshoCd,
          juchuEntryYmd,
          juchuNo,
          juchuShuseiCount,
        } = params;
        const res = await axios({
          url: `${API_G_030_JUCHU_TOIAWASE}/${juchuEntryJigyoshoCd}/${dateStrToNum(juchuEntryYmd)}/${juchuNo}/${juchuShuseiCount}`,
          method: 'GET',
          params: removeBlankOrNullOrZero(params),
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getUchiwake error.');
        console.log(err);
      }
    },
    async putShukkaAnnaiIkkatsu(_ctx, params) {
      try {
        const res = await axios({
          url: `${API_G_030_JUCHU_TOIAWASE}/shukkaAnnaiIkkatsu/`,
          method: 'PUT',
          data: params,
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api putShukkaAnnaiIkkatsu error.');
        console.log(err);
      }
    },
    async putShukkaAnnai(_ctx, params) {
      try {
        const {
          shukkaJigyoshoCd,
          shukkaEntryYmd,
          shukkaNo,
        } = params;
        const res = await axios({
          url: `${API_G_030_JUCHU_TOIAWASE}/shukkaAnnaiUpd/${shukkaJigyoshoCd}/${dateStrToNum(shukkaEntryYmd)}/${shukkaNo}`,
          method: 'PUT',
          params: removeBlankOrNullOrZero(params),
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api putShukkaAnnai error.');
        console.log(err);
      }
    },
    async putNohinshoIkkatsu(_ctx, params) {
      try {
        const res = await axios({
          url: `${API_G_030_JUCHU_TOIAWASE}/nohinshoIkkatsu/`,
          method: 'PUT',
          data: params,
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api putNohinshoIkkatsu error.');
        console.log(err);
      }
    },
    async putNohinsho(_ctx, params) {
      try {
        const {
          uriageEntryJigyoshoCd,
          uriageEntryYmd,
          uriageNo,
          uriageShuseiCount,
        } = params;
        const res = await axios({
          url: `${API_G_030_JUCHU_TOIAWASE}/nohinshoUpd/${uriageEntryJigyoshoCd}/${dateStrToNum(uriageEntryYmd)}/${uriageNo}/${uriageShuseiCount}`,
          method: 'PUT',
          params: removeBlankOrNullOrZero(params),
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api putNohinsho error.');
        console.log(err);
      }
    },
    async putJuchuUkeIkkatsu(_ctx, params) {
      try {
        const res = await axios({
          url: `${API_G_030_JUCHU_TOIAWASE}/juchuUkeIkkatsu/`,
          method: 'PUT',
          data: params,
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api putJuchuUkeIkkatsu error.');
        console.log(err);
      }
    },
    async putJuchuUke(_ctx, params) {
      try {
        const {
          juchuEntryJigyoshoCd,
          juchuEntryYmd,
          juchuNo,
          juchuShuseiCount,
        } = params;
        const res = await axios({
          url: `${API_G_030_JUCHU_TOIAWASE}/juchuUkeUpd/${juchuEntryJigyoshoCd}/${dateStrToNum(juchuEntryYmd)}/${juchuNo}/${juchuShuseiCount}`,
          method: 'PUT',
          params: removeBlankOrNullOrZero(params),
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api putJuchuUke error.');
        console.log(err);
      }
    },
    async postCsvData(_ctx, requestData) {
      try {
        const res = await axios({
          url: `${API_G_030_JUCHU_TOIAWASE}/csvData/`,
          method: 'POST',
          data: {
            requestData,
          },
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api postCsvData error.');
        console.log(err);
      }
    },
  },
};

export default g_030;
